import { CreateUser } from "@/types/user";
import { DEFAULT_LANGUAGE } from "@/i18n";

export const defaultUserValues: CreateUser = {
  email: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  system_role_id: "",
  preferred_language_iso_code: DEFAULT_LANGUAGE,
  register_as_contractor: false,
  tax_status: undefined,
  payroll_comment: undefined,
};
